export const CLINICAL_FORM_NOM = 'nom_005_ssa3_2018';
export const CLINICAL_FORM_REHABILITA = 'rehabilita';
export const CLINICAL_FORM_PELUQUERIA = 'peluqueria_v1';
export const CLINICAL_FORM_DENTAL = 'dental_v1';
export const CLINICAL_FORM_GENERAL = 'consultorio_general_v1';

export const DEFAULT_CLINICAL_FORM_TEMPLATE = CLINICAL_FORM_REHABILITA;

export const CLINICAL_FORM_TEMPLATES = {
  [CLINICAL_FORM_NOM]: {
    id: CLINICAL_FORM_NOM,
    label: 'Podología',
    description: 'Historia clínica completa (NOM) con consentimiento informado.',
    rubro: 'podologia',
    hasConsent: true,
    encounterAllowsFiles: false,
  },
  [CLINICAL_FORM_REHABILITA]: {
    id: CLINICAL_FORM_REHABILITA,
    label: 'Fisioterapia / Rehabilitá',
    description: 'Formato breve de fisioterapia / rehabilitación (sin consentimiento).',
    rubro: 'fisioterapia',
    hasConsent: false,
    encounterAllowsFiles: false,
  },
  [CLINICAL_FORM_PELUQUERIA]: {
    id: CLINICAL_FORM_PELUQUERIA,
    label: 'Peluquería',
    description: 'Citas / notas de evolución con fechas y fotos (sin historia clínica larga).',
    rubro: 'peluqueria',
    hasConsent: false,
    encounterAllowsFiles: true,
    /** Solo notas de evolución; no wizard de historia inicial. */
    visitsOnly: true,
  },
  [CLINICAL_FORM_DENTAL]: {
    id: CLINICAL_FORM_DENTAL,
    label: 'Clínica dental',
    description: 'Historia odontológica; en cada seguimiento se pueden subir fotos y archivos (PDF).',
    rubro: 'dental',
    hasConsent: true,
    encounterAllowsFiles: true,
  },
  [CLINICAL_FORM_GENERAL]: {
    id: CLINICAL_FORM_GENERAL,
    label: 'Consultorio general',
    description:
      'Historia clínica de medicina general; notas de seguimiento imprimibles con médico y cédula de Settings.',
    rubro: 'consultorio_general',
    hasConsent: true,
    encounterAllowsFiles: true,
  },
};

export function clinicalFormTemplateOptions() {
  return Object.values(CLINICAL_FORM_TEMPLATES);
}

export function clinicalFormHasConsent(templateId) {
  return Boolean(CLINICAL_FORM_TEMPLATES[templateId]?.hasConsent);
}

export function clinicalFormAllowsEncounterFiles(templateId) {
  return Boolean(CLINICAL_FORM_TEMPLATES[templateId]?.encounterAllowsFiles);
}

export function clinicalFormVisitsOnly(templateId) {
  return Boolean(CLINICAL_FORM_TEMPLATES[templateId]?.visitsOnly);
}

function activeSettingsTemplate(settingsTemplate) {
  const configured = String(settingsTemplate || '').trim();
  if (configured && CLINICAL_FORM_TEMPLATES[configured]) return configured;
  return DEFAULT_CLINICAL_FORM_TEMPLATE;
}

function storedIntakeTemplate(intake) {
  const onRecord = String(intake?.form_template || '').trim();
  if (onRecord && CLINICAL_FORM_TEMPLATES[onRecord]) return onRecord;
  if (intake?.personal || Number(intake?.schema_version) === 2) return CLINICAL_FORM_NOM;
  if (intake?.salon_history !== undefined || intake?.hair_type !== undefined) {
    return CLINICAL_FORM_PELUQUERIA;
  }
  if (intake?.dental_history !== undefined || intake?.odontogram !== undefined) {
    return CLINICAL_FORM_DENTAL;
  }
  if (
    intake?.current_illness !== undefined ||
    intake?.physical_exam !== undefined ||
    (intake?.form_template === CLINICAL_FORM_GENERAL)
  ) {
    return CLINICAL_FORM_GENERAL;
  }
  if (
    intake?.historia !== undefined ||
    intake?.plan_tx !== undefined ||
    intake?.dx !== undefined ||
    intake?.ap !== undefined
  ) {
    return CLINICAL_FORM_REHABILITA;
  }
  return null;
}

/**
 * Borradores: siempre la plantilla activa en ajustes (un solo formulario en la clínica).
 * Completados: conservan la plantilla con la que se finalizó la historia.
 */
export function resolveClinicalFormTemplate(intake, settingsTemplate, recordStatus = 'draft') {
  const active = activeSettingsTemplate(settingsTemplate);
  if (String(recordStatus || '').toLowerCase() !== 'complete') {
    return active;
  }
  return storedIntakeTemplate(intake) || active;
}

/** Título del formulario de historia clínica (plantilla breve / marca). */
export function formatClinicalHistoryTitle(businessName, fallback = 'Centro Cultural') {
  const brand = String(businessName || '').trim() || String(fallback || '').trim() || 'Centro Cultural';
  return `Historia clínica — ${brand}`;
}
